import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GmdService } from '../../services/gmd.service';
import { ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { LoadingService } from 'axis-components/components/loading/loading.service';

@Component({
  selector: 'app-view-results',
  templateUrl: './view-results.component.html',
  styleUrls: ['./view-results.component.scss']
})
export class ViewResultsComponent implements OnInit, AfterViewInit {

  public viewResults;
  public regions;
  public countries;
  public selectedRegion;
  public selectedCountry;
  public disableSearch = true;
  public regionIndex = 0;
  public countryIndex = 0;
  public viewResultsForm: FormGroup;
  public recipientMail;
  public groupedResults;
  public objectKeys = Object.keys;
  public objectValues = Object.values;
  constructor(private gmdService: GmdService, private fb: FormBuilder, private changeDetectorRef: ChangeDetectorRef, public loadingService: LoadingService) { }

  ngOnInit(): void {
    this.viewResultsForm = this.fb.group({
      region: ['', [Validators.required]],
      country: ['', [Validators.required]]
    });
    this.gmdService.getRegions().subscribe((obs)=> 
    {
      this.regions = obs;
      if (this.regions) {
        this.regions.forEach((e, i) => {
          if (e.regionId.toString() === regionId) {
            this.selectedRegion = this.regions[i];
            this.regionIndex = i;
            this.gmdService.getCountries({ regionId: this.selectedRegion.regionId}).subscribe((obsCountry) => {
              this.countries = obsCountry;
              if (this.countries) {
                this.countries.forEach((element, index) => {
                  if (element.countryId.toString() === countryId) {
                    this.selectedCountry = this.countries[index];
                    this.countryIndex = index;
                    this.viewResultsForm.get('region').setValue(e.regionName);
                    this.changeDetectorRef.detectChanges();
                  }
                });
              }
            });
          }
        });
      }
    });
    const regionId = sessionStorage.getItem('selectedRegionIdLanding');
    const countryId = sessionStorage.getItem('selectedCountryIdLanding');
    if (regionId && countryId) {
      this.loadingService.start();
      this.disableSearch =  false;
      const req = { 
        "regionId" : regionId,
        "countryId": countryId
      };
      this.gmdService.searchCompany(req).subscribe((obs)=>
      {
        this.viewResults = obs;
        this.groupedResults = _.groupBy(this.viewResults, 'locationName');
        this.loadingService.stop();
        sessionStorage.removeItem('selectedRegionIdLanding');
        sessionStorage.removeItem('selectedCountryIdLanding');
      });
    }
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  public getRecipientMail(mail) {
    this.recipientMail = 'mailto:' + mail;
  }

  touch(trv) {
    trv.isTouched = true;
  }

  onRegionSelected(selectedRegion) {
    this.countries = [];
    this.selectedCountry = '';
    this.viewResultsForm.get('country').setValue('');
    this.disableSearch = true;
    this.regionIndex = 0;
    this.countryIndex = 0;
    this.validate();
    if (selectedRegion && selectedRegion !== null) {
      this.selectedRegion = selectedRegion.regionId;
      this.gmdService.getCountries({ regionId: selectedRegion.regionId }).subscribe((obs)=> this.countries = obs);
    }
  }

  onCountrySelected(selectedCountry) {
    this.disableSearch = true;
    if (selectedCountry && selectedCountry !== null) {
      this.selectedCountry = selectedCountry.countryId;
    }
    this.validate();
  }

  patchRegionValue() {
    if (this.regions &&  this.regions.length > 0) {
      const regionId = this.selectedRegion.regionId;
      this.regions.forEach((rg) => {
        if (rg.regionId === regionId) {
          this.viewResultsForm.get('region').setValue(rg.regionName);
          this.changeDetectorRef.detectChanges();
        }
      });
    }
  }

  patchFormValue() {
    if (this.countries && this.countries.length > 0) {
      const countryId = this.selectedCountry.countryId;
      this.countries.forEach((cn) => {
        if (cn.countryId === countryId) {
          this.viewResultsForm.get('country').patchValue(cn.countryName);
          this.changeDetectorRef.detectChanges();
        }
      })
    }
  }

  public search() {
    this.loadingService.start();
    const req = { 
      "regionId" : this.selectedRegion.regionId || this.selectedRegion,
      "countryId": this.selectedCountry.countryId || this.selectedCountry
    };
    this.gmdService.searchCompany(req).subscribe((obs)=>
    {
      this.viewResults = obs;
      this.groupedResults = _.groupBy(this.viewResults, 'locationName');
      this.loadingService.stop();
    });
  }

  public clear(): void {
    this.viewResults = [];
    this.viewResultsForm.reset();
    sessionStorage.setItem('selectedRegionIdLanding', '');
    sessionStorage.setItem('selectedCountryIdLanding', '');
    this.disableSearch = true;
    this.countries = [];
  }

  public validate() {
    if ((this.viewResultsForm.get('region').value !== null && this.viewResultsForm.get('region').value !== '') &&
      (this.viewResultsForm.get('country').value !== null && this.viewResultsForm.get('country').value !== '')) {
      this.disableSearch = false;
    } else {
      this.disableSearch = true;
    }
  }
  public downloadCSV() {
    this.gmdService.downloadCSV().subscribe((obs)=> {
      const blob = new Blob([obs], { type: 'text/csv;charset=utf-8' });
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.download = `Marine Claims Worldwide Directory.csv`;
      a.href = data;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(data);
      a.remove();
    });
  }
  public downloadPDF() {
    this.gmdService.downloadPDF().subscribe((obs)=> {
      const blob = new Blob([obs], { type: 'text/pd;charset=utf-8' });
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.download = `Marine Claims Worldwide Directory.pdf`;
      a.href = data;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(data);
      a.remove();
    });
  }
}
